module.exports = __webpack_public_path__ + "img/sms-1-1.dc5b3cd9.png";